import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Icon, IconClose } from "../../../base/icons";

import {
    setChangeAcient,
    setChatFirstWordDetect,
    setChatLanguageGenders,
    setChatUserSpeak,
    setSelectLang,
    setStartSpeechTimer
} from "./reducer/actions";
import { createToolbarEvent, sendAnalytics } from "../../../analytics";
import { setOverflowMenuVisible } from "../../../toolbox/actions.web";
import toast from "react-simple-toasts";
import { usePrevious } from "../../welcome-dashboard/Utils";
import { setChatTranslateMessage } from "../../redux/tool-webjam-v2/actions";
import { toggleChat } from "../../../chat/actions"
import { CURRENT_ROOM_NAME, Constant } from "../../../webjam/constant";
import { getStore } from "../../Utils";
import { getVoiceDetect } from "../../welcome-dashboard/Request.d";
import { CHAT_CUSTOM_STORE } from "./reducer/chat-reducer";
import { FEATURE_CUSTOM_REDUX_V2 } from "../../constant";
import { Tooltip } from "@material-ui/core"
import { hideApiLoader, showApiLoader, showToastPopup } from "../../redux/tool-webjam/actions";
import { ct } from "../../constant-Utils";


let whoIsSpeaking, genderSpeaking;

const NativeSpeechRecognition = typeof window !== 'undefined' && (
    window.SpeechRecognition ||
    window.webkitSpeechRecognition ||
    window.mozSpeechRecognition ||
    window.msSpeechRecognition ||
    window.oSpeechRecognition
)
var recognition, recognizing;

const allLanguages = {
    "English (US)": { langCode: 'en-US', gender: ["Male", "Female"] },
    "Afrikaans (South Africa)": { langCode: 'af-ZA', gender: ["Female"] },
    "Arabic": { langCode: 'ar-XA', gender: ["Male", "Female"] },
    "Bulgarian (Bulgaria)": { langCode: 'bg-BG', gender: ["Female"] },
    "Catalan (Spain)": { langCode: 'ca-ES', gender: ["Female"] },
    "Chinese": { langCode: 'zh-CN', gender: ["Male", "Female"] },
    "Czech (Czech Republic)": { langCode: 'cs-CZ', gender: ["Female"] },
    "Danish (Denmark)": { langCode: 'da-DK', gender: ["Male", "Female"] },
    "Dutch (Belgium)": { langCode: 'nl-BE', gender: ["Male", "Female"] },
    "Dutch (Netherlands)": { langCode: 'nl-NL', gender: ["Male", "Female"] },
    "English (Australia)": { langCode: 'en-AU', gender: ["Male", "Female"] },
    "English (India)": { langCode: 'en-IN', gender: ["Male", "Female"] },
    "English (UK)": { langCode: 'en-GB', gender: ["Male", "Female"] },
    "Filipino (Philippines)": { langCode: 'fil-PH', gender: ["Male", "Female"] },
    "Finnish (Finland)": { langCode: 'fi-FI', gender: ["Female"] },
    "French (Canada)": { langCode: 'fr-CA', gender: ["Male", "Female"] },
    "French (France)": { langCode: 'fr-FR', gender: ["Male", "Female"] },
    "German (Germany)": { langCode: 'de-DE', gender: ["Male", "Female"] },
    "Greek (Greece)": { langCode: 'el-GR', gender: ["Female"] },
    "Hindi (India)": { langCode: 'hi-IN', gender: ["Male", "Female"] },
    "Hungarian (Hungary)": { langCode: 'hu-HU', gender: ["Female"] },
    "Icelandic (Iceland)": { langCode: 'is-IS', gender: ["Female"] },
    "Indonesian (Indonesia)": { langCode: 'id-ID', gender: ["Male", "Female"] },
    "Italian (Italy)": { langCode: 'it-IT', gender: ["Male", "Female"] },
    "Japanese (Japan)": { langCode: 'ja-JP', gender: ["Male", "Female"] },
    "Korean (South Korea)": { langCode: 'ko-KR', gender: ["Male", "Female"] },
    "Latvian (Latvia)": { langCode: 'lv-LV', gender: ["Male"] },
    "Malay (Malaysia)": { langCode: 'ms-MY', gender: ["Male", "Female"] },
    "Norwegian (Norway)": { langCode: 'nb-NO', gender: ["Male", "Female"] },
    "Polish (Poland)": { langCode: 'pl-PL', gender: ["Male", "Female"] },
    "Portuguese (Brazil)": { langCode: 'pt-BR', gender: ["Male", "Female"] },
    "Portuguese (Portugal)": { langCode: 'pt-PT', gender: ["Male", "Female"] },
    "Romanian (Romania)": { langCode: 'ro-RO', gender: ["Female"] },
    "Russian (Russia)": { langCode: 'ru-RU', gender: ["Male", "Female"] },
    "Serbian (Cyrillic)": { langCode: 'sr-RS', gender: ["Female"] },
    "Slovak (Slovakia)": { langCode: 'sk-SK', gender: ["Female"] },
    "Spanish (Spain)": { langCode: 'es-ES', gender: ["Male", "Female"] },
    "Spanish (US)": { langCode: 'es-US', gender: ["Male", "Female"] },
    "Swedish (Sweden)": { langCode: 'sv-SE', gender: ["Male", "Female"] },
    "Thai (Thailand)": { langCode: 'th-TH', gender: ["Female"] },
    "Turkish (Turkey)": { langCode: 'tr-TR', gender: ["Male", "Female"] },
    "Ukrainian (Ukraine)": { langCode: 'uk-UA', gender: ["Female"] },
    "Vietnamese (Vietnam)": { langCode: 'vi-VN', gender: ["Male", "Female"] }
}
const availableLangGender = {};

if (!Object.keys(availableLangGender).length) {
    Object.keys(allLanguages).map((e, i) => {
        availableLangGender[allLanguages[e].langCode] = allLanguages[e].gender;
    })
}

const ChatHeader = (props) => {
    const dispatch = useDispatch()
    const [transSectionClass, setTransSectionClass] = useState('')
    const [isSpeakerOpen, setIsSpeakerOpen] = useState(false)
    const [isSpeakManual, setIsSpeakManual] = useState(false)
    const [speak, setSpeak] = useState(false)
    const [voicelist, setVoicelist] = useState('');
    const [languagesName, setLanguagesName] = useState([]);
    const [languagesNameCode, setLanguagesNameCode] = useState({});
    const [languagesGenderAll, setLanguagesGenderAll] = useState({});
    const [chatFirstWord, setChatFirstWord] = useState("");
    const [localLanguage, setLocalLanguage] = useState("");
    const langRef = useRef()
    const genderRef = useRef()
    // const [chatFirstWordDetect, setChatFirstWordDetect] = useState(false);

    const audioMuted = useSelector(state => state["features/base/media"]?.audio?.muted);

    let prevAudio = usePrevious(audioMuted)

    useEffect(() => {
        if (prevAudio != audioMuted) {
            if (audioMuted) {
                // setIsSpeakerOpen(false)
                setUserSpeaking(false);
                stopSpeakUser()
            }
        }
    }, [audioMuted]);

    // useEffect(() => {
    //     console.log("chatTranslatorStatuschatTranslatorStatus ", props.chatTranslatorStatus, recognizing)
    //     if (props.chatTranslatorStatus == false) {
    //         if (recognizing) {
    //             setUserSpeaking(false)
    //             recognition.stop()
    //         }
    //     }
    // }, [props.chatTranslatorStatus])

    const { isChatFirstWordDetect } = props;
    let prevChatWordDetect = usePrevious(isChatFirstWordDetect)
    useEffect(() => {
        if (!props._lang && chatFirstWord) {
            let room = CURRENT_ROOM_NAME;
            // if (room) {
            //     room = room.substring(1);
            // }

            let time = Math.round(new Date().getTime() / 1000);
            let willTrigger = false;
            let prevConf = sessionStorage.getItem("conference_chat_t_" + room);
            // console.log("prev config ", prevConf, " new time ", time, "Diff ", (time - prevConf))
            if (prevConf) {
                if (!isNaN(prevConf)) {
                    if (time - prevConf > 1) {
                        willTrigger = true;
                    }
                } else {
                    willTrigger = true;
                }
            } else {
                willTrigger = true;
            }

            if (willTrigger) {
                sessionStorage.setItem("conference_chat_t_" + room, time);
                getVoiceDetect({
                    l: chatFirstWord
                }).then(async data => {
                    // console.log("language received ", data, "dasssssss ", languagesNameCode[data.language])
                    if (data.language) {
                        let _setLang = "";

                        let defaultTimer = 0;
                        if (languagesNameCode[data.language] != undefined) {
                            _setLang = languagesNameCode[data.language]
                        } else {
                            // toast("Unable to detect you language, please choose one from drop down or English(US) will be set default.");
                            dispatch(showToastPopup({ toastModal: true, modalText: ct("rta-trmc.chat.detectLanguage") }));
                            defaultTimer = 5000;
                            _setLang = "en-US"
                        }

                        setTimeout(function () {
                            dispatch(showToastPopup({ toastModal: false, modalText: "" }));
                            changeLang({
                                target: {
                                    value: _setLang
                                }
                            }, 1)

                            let _langGender = setLanguageGen({
                                target: {
                                    value: _setLang
                                }
                            })

                            changeLangForm({
                                target: {
                                    value: _langGender[1] ?? _langGender[0]
                                }
                            });

                            dispatch(setChatTranslateMessage(chatFirstWord, false))
                            setTimeout(function () {
                                dispatch(setChatTranslateMessage(chatFirstWord, true))
                            }, 1000)
                        }, defaultTimer)
                    }
                })
            }
        }
    }, [chatFirstWord])

    useEffect(() => {
        if (props.enableTranslate && props.chatTranslatorStatus) {
            let languages = [<option value="" key={1}>{ct("rta-trmc.chat.selectLanguage")}</option>];
            let languagesGender = {};
            let languagesNameC = {};
            Object.keys(allLanguages).map((e, i) => {
                languages.push(<option key={allLanguages[e].langCode} value={allLanguages[e].langCode}>{e}</option>)
                languagesGender[allLanguages[e].langCode] = allLanguages[e].gender;

                let fltr = allLanguages[e].langCode.split("-")[0];

                languagesNameC[fltr] = allLanguages[e].langCode;
            })
            setLanguagesName(languages)
            setLanguagesGenderAll(languagesGender)

            dispatch(setChatLanguageGenders(languagesGender));

            setLanguagesNameCode(languagesNameC)

            setTimeout(function () {
                setUserSpeaking(true);
                startSpeakUser()
                setSpeak(true);
                if (props._lang != "" && props._langForm) {
                    try {
                        setLanguageGen({
                            target: {
                                value: props._lang
                            }
                        }, languagesGender)
                    } catch (e) {
                        console.log("unable to set after gender ", e)
                    }
                }
            }, 100)
        } else {
            console.log("translate will not work")
        }

        let chatTimer = setInterval(function () {
            let allStore = getStore('features/customise/app/chat');
            let isUserSpeaking = allStore.chatUserSpeaking;
            let startSpeechTimer = allStore.startSpeechTimer;
            let time = Math.round(new Date().getTime() / 1000)

            if (time - startSpeechTimer > 25) {
                if (recognizing) {
                    console.log("restart after interval ")
                    recognition.stop()
                }
            }
        }, 30000)

        return () => {
            dispatch(setChatLanguageGenders(""));

            if (recognizing) {
                setUserSpeaking(false)
                recognition.stop()
            }
        }
    }, []);

    const [speakingGender, setSpeakingGender] = useState([
        <option key={0} value="">{ct("rta-trmc.chat.selectGender")}</option>
    ])

    useEffect(() => {
        speakLastMessage();
    }, [props._messages])

    const divclicked = () => {
        setTransSectionClass(!transSectionClass ? "show-hide" : '')
    }

    const initTranscript = (language) => {
        try {
            if (NativeSpeechRecognition) {
                try {
                    recognition = new webkitSpeechRecognition();
                } catch (e) {
                    recognition = Object;
                }
                if (props.enableTranslate) {
                    let uLang = language;

                    if (!uLang) uLang = props._lang;
                    if (!uLang) uLang = "en-GB";


                    recognition.lang = uLang;
                    if (language == "") dispatch(setChatFirstWordDetect(false))

                    // recognition.lang = "en";
                    recognition.continuous = true;
                    recognition.interimResults = true;
                    recognition.onspeechend = function (e) {
                        // console.log("sppech ended ", e)
                    }
                    recognition.onstart = function () {
                        // In case if speech is started/restarted then send previous message first, sometime is not sending current message in same case
                        let getCurrentMessage = getStore(FEATURE_CUSTOM_REDUX_V2).chatTranslateMessage;
                        if (getCurrentMessage != "") {
                            // console.log("last message send");
                            setTimeout(function () {
                                if (!sessionStorage.getItem("chat_se")) {
                                    dispatch(setChatTranslateMessage(getCurrentMessage, true))
                                }
                            }, 1000)
                        }
                        console.log("start listen")
                        dispatch(setStartSpeechTimer(Math.round(new Date().getTime() / 1000)))
                        recognizing = true;
                    };

                    recognition.onerror = function (event) {
                        console.log("chat error ", event)
                        recognizing = false;
                    };
                    recognition.onend = function () {
                        // speechOn(false, 3)
                        console.log("stop listen")
                        speechEnded()
                        recognizing = false;
                    }

                    recognition.onresult = function (event) {
                        let willSend = false;

                        let interim_transcript = "";

                        for (var i = event.resultIndex; i < event.results.length; ++i) {
                            interim_transcript += event.results[i][0].transcript;
                            if (event.results[i].isFinal) {
                                willSend = true;
                            } else {
                                willSend = false;
                            }
                        }
                        // console.log("final", willSend)

                        if (willSend) {
                            setChatFirstWord(interim_transcript)
                            dispatch(setChatFirstWordDetect(true))
                        }
                        let _getStore = getStore(CHAT_CUSTOM_STORE)

                        if (_getStore.lang == "") {
                            willSend = false
                        }

                        if (_getStore.lang != "" && _getStore.langForm == "") {
                            console.log("my language is selected but gender is not selected")
                            let langGender = setLanguageGen({
                                target: {
                                    value: _getStore.lang
                                }
                            })

                            changeLangForm({
                                target: {
                                    value: langGender[1] ?? langGender[0]
                                }
                            });
                        }
                        dispatch(setChatTranslateMessage(interim_transcript, willSend))
                    };

                    recognition.onerror = function (e) {
                        if (e.error === 'audio-capture') {
                            recognition.dontReTry = true;
                            console.error('No microphone was found. Ensure that a microphone is installed and that microphone settings are configured correctly. https://support.google.com/chrome/bin/answer.py?hl=en&answer=1407892');
                            console.error('Original', e.type, e.message.length || e);
                            return;
                        }
                    };
                } else {
                    if (recognizing) {
                        dispatch(setChatUserSpeak(false))
                        recognition.stop()
                    }
                }
            } else {
                toast(ct('rta-trmc.chat.translationNotSupport'), Constant.App.ToastTime.LongCloseTime)
            }
        } catch (e) {
            console.log("eeeeeeeeeeeeeeeeeeeee ", e)
        }
    }

    const startSpeak = (preDefinLang = props._lang) => {
        if (!preDefinLang) preDefinLang = localLanguage;
        if (NativeSpeechRecognition) {
            try {
                initTranscript(preDefinLang)
                if (recognizing) {
                    recognition.stop()
                }
                setTimeout(function () {
                    recognition.start();
                }, 400)
            } catch (e) {
                console.log("speech error", e)
            }
        }
    }

    const startSpeakUser = (lang = '') => {
        setIsSpeakerOpen(true);
        startSpeak(lang);

        // setTimeout(() => {
        //     if (recognizing) {
        //         recognition.stop()
        //     }
        //     console.log("stop manually")
        // }, 30000)
    }

    const speechEnded = () => {
        const gets = getStore('features/customise/app/chat')
        if (gets.chatUserSpeaking) {
            let room = CURRENT_ROOM_NAME;
            // if (room) {
            //     room = room.substring(1);
            // }

            let time = new Date().getTime();
            let willTrigger = false;
            let prevConf = sessionStorage.getItem("conference_chat_" + room);
            console.log("will start ", prevConf, "new", time, "diff ", (time - prevConf))
            if (prevConf) {
                if (!isNaN(prevConf)) {
                    if (time - prevConf > 450) {
                        willTrigger = true;
                    }
                } else {
                    willTrigger = true;
                }
            } else {
                willTrigger = true;
            }

            if (willTrigger) {
                sessionStorage.setItem("conference_chat_" + room, time);
                startSpeakUser(gets.lang)
                console.log("restarted speech")
            }
        }
    }

    const stopSpeakUser = () => {
        setIsSpeakerOpen(false);
        if (recognizing) {
            recognition.stop()
        }
    }

    const setUserSpeaking = (type) => {
        dispatch(setChatUserSpeak(type))
    }
    const setLanguageGen = (e, languageProvided = "") => {
        let setGender = [<option key={0} value="">{ct("rta-trmc.chat.selectGender")}</option>];

        let allLangGend = languagesGenderAll;

        if (!Object.keys(allLangGend).length) {
            if (languageProvided) {
                allLangGend = languageProvided;
            }
        }

        if (!Object.keys(allLangGend).length) {
            if (availableLangGender) {
                allLangGend = availableLangGender;
            }
        }

        let langGender = [""];

        if (allLangGend[e.target.value]) {
            allLangGend[e.target.value].map(e => {
                langGender.push(e)
                setGender.push(<option key={Math.random()} value={e}>{ct(`rta-trmc.chat.${e}`)}</option>)
            })
        }
        setSpeakingGender(setGender);
        return langGender;
    }

    const changeLang = (e, isAutoDetect = '') => {

        if (isAutoDetect == '') {
            // setUserSpeaking(false);
            // stopSpeakUser()
            // setIsSpeakerOpen(false)
            // if (recognition) {
            //     recognition.stop()
            // }
        } else {

        }

        if (recognizing) {
            setUserSpeaking(false);
            recognition.stop()
        }

        if (e?.target?.value) {
            dispatch(showApiLoader({
                loaderAdditionalDetail: ct("rta-trmc.chat.pleaseWait")
            }));

            setTimeout(function () {
                dispatch(hideApiLoader())
            }, 1000)
        }

        sessionStorage.setItem("chat_se", 1)
        setTimeout(function () {
            setUserSpeaking(true);
            startSpeak(e.target.value);
        }, 1000)

        dispatch(setSelectLang(e.target.value));
        setLocalLanguage(e.target.value);
        let langGender = setLanguageGen(e)

        changeLangForm({
            target: {
                value: langGender[0]
            }
        });
    }

    const changeLangForm = (e) => {
        const { target: { value } } = e;
        genderSpeaking = value;
        dispatch(setChangeAcient(e.target.value));
    }

    const _onToolbarToggleChat = () => {
        sendAnalytics(createToolbarEvent(
            'toggle.chat',
            {
                enable: !props._chatOpen
            }));

        dispatch(setChatUserSpeak(false));
        dispatch(setChatFirstWordDetect(false))
        if (recognizing) {
            recognition.stop()
        }

        if (props._overflowMenuVisible) {
            dispatch(setOverflowMenuVisible(false));
        }
        dispatch(toggleChat())
    }

    const speakLastMessage = () => {

        var { _messages, _isOpen, _lang, _langForm, chatSenderLanguage } = props;
        const messageCount = _messages.length;
        const lastMessage = _messages[messageCount - 1];

        if (chatSenderLanguage) {
            if (_lang) {
                if (languagesGenderAll[_lang] != undefined) {
                    if (!languagesGenderAll[_lang].includes(chatSenderLanguage)) {
                        chatSenderLanguage = languagesGenderAll[_lang][0]
                    }
                }
            }
        }

        if (chatSenderLanguage) {
            chatSenderLanguage = chatSenderLanguage.toUpperCase()
            if (["FEMALE", "MALE"].indexOf(chatSenderLanguage) == -1) {
                chatSenderLanguage = "";
            }
        }

        // not speak local message

        console.log("chat error ", _isOpen, "messageCount ", messageCount, "speak", speak, "lastMessage", lastMessage)
        if (_isOpen && messageCount && speak && lastMessage.messageType !== 'local') {
            const { displayName, message, langForm, id } = lastMessage;

            chatSenderLanguage = chatSenderLanguage.toUpperCase();

            let userTextAudio = Constant.App.chatTranslate + "/translate?text=" + message + "&lang=" + _lang + "&gender=" + chatSenderLanguage;
            console.log("genderSpeaking------------zz ", userTextAudio);

            let au = "";
            if (au) {
                au.stop()
            }
            au = new Audio(userTextAudio);
            au.play();

            // //setTimeout(() => {
            // if (!whoIsSpeaking || whoIsSpeaking !== id) {
            //     // window.responsiveVoice.speak(`${displayName} said ${message}`, genderSpeaking);

            //     au.play();
            //     whoIsSpeaking = id;
            // } else {
            //     console.log("genderSpeaking------------b ", genderSpeaking);
            //     // speaks the last message from remote
            //     // window.responsiveVoice.speak(message, genderSpeaking);
            //     let au = new Audio(Constant.App.chatTranslate + "/translate?text=" + message + "&lang=" + _lang + "&gender=" + chatSenderLanguage);
            //     au.play();
            // }
            // //}, 2000);
        }
    }


    const handleLangClick = () => {
    }

    const handleGenderClick = () => {
    }

    // const renderInput = () => {
    //     let {
    //         _availableDevices
    //     } = props;
    //     try {
    //         let inputId = _availableDevices.audioInput[1].deviceId;

    //         let stream = window.navigator.mediaDevices.getUserMedia({
    //             "video": false,
    //             "audio": {
    //                 "autoGainControl": true, "deviceId": inputId, "echoCancellation": true, "noiseSuppression": true
    //             }
    //         });
    //         let audio = new Audio()
    //         audio.srcObject = window.URL.createObjectURL(stream)
    //         console.log("streamstream ", stream)
    //     } catch (e) {
    //         console.log("audio error ", e)
    //     }

    // }

    const { enableTranslate, enableClose, headerClass } = props;
    return (
        <div className={`chat-header ${headerClass ? headerClass : ""}`} >

            {/* {renderInput()} */}
            < div className={`speech-translation ${headerClass ? headerClass : ""}`}>
                <div id="speech-translation__btn">
                    {/* {
                        enableTranslate && <button className="show-translation " onClick={divclicked}>Live Speech Translation</button>
                    } */}

                    {
                        enableClose && <div className='chat-close'
                            onClick={_onToolbarToggleChat}
                        >
                            <Icon src={IconClose} />
                        </div>
                    }

                </div>
                {
                    enableTranslate &&
                    <div id="speech-translation__section" className={transSectionClass}>
                        <div className='chat-trans-tools'>
                            <div className={`mic-speak ${!('webkitSpeechRecognition' in window) ? 'firefox' : ''}`}>
                                {isSpeakerOpen ?
                                    <div className="input-group-addon" id="btn-convert-voice" title={ct("rta-trmc.chat.stopConvertingVoice")} style={{ cursor: 'pointer' }} onClick={() => {
                                        setUserSpeaking(false);
                                        stopSpeakUser();
                                    }}><i className="fa fa-microphone"></i></div> :
                                    <div className="input-group-addon" id="btn-convert-voice-close" title={ct("rta-trmc.chat.SpeakConvertVoice")} style={{ cursor: 'pointer' }} onClick={() => {
                                        setUserSpeaking(true);
                                        startSpeakUser()
                                    }}><i className="fa fa-microphone-slash" /></div>
                                }
                                {speak ?
                                    <div className="speak-addon" id="btn-convert-voice" title={ct("rta-trmc.chat.tunOffRobot")} style={{ cursor: 'pointer' }} onClick={() => setSpeak(false)}><i className="fa fa-volume-up" /></div> :
                                    <div className="speak-addon" id="btn-convert-voice-close" title={ct("rta-trmc.chat.robotCanSpeak")} style={{ cursor: 'pointer' }} onClick={() => setSpeak(true)}><i className="fa fa-volume-off" /><span className="speech-cross"></span></div>
                                }
                            </div>
                            <div className="languages">
                                <div style={{ position: "relative" }}>
                                    <i className="fa fa-angle-down" style={{ position: "absolute", left: "135px", top: "8px", fontSize: "19px", cursor: "pointer" }} onClick={handleLangClick}  ></i>
                                    <select id="convert-from" className="form-control"
                                        value={props._lang}
                                        onChange={changeLang}
                                        ref={langRef}
                                    >{languagesName}
                                    </select>
                                    <Tooltip title={ct('rta-trmc.chat.speakInYourLang')} placement="right" arrow
                                        id="chat-info-x"
                                    >
                                        <img src="/images/info.svg" height="25px" width="25px" className="chat-info-b" />
                                    </Tooltip>
                                </div>
                                <div style={{ position: "relative" }}>
                                    <i className="fa fa-angle-down" style={{ position: "absolute", left: "100px", top: "12px", fontSize: "19px", cursor: "pointer" }} onClick={handleGenderClick}  ></i>
                                    <select id="voiceselection"
                                        value={props._langForm}
                                        onChange={changeLangForm}
                                        ref={genderRef}

                                    >
                                        {speakingGender}
                                    </select>
                                    <Tooltip title={ct("rta-trmc.chat.selectGenderTooltip")} placement="right" arrow
                                        id="chat-info-y"
                                    >
                                        <img src="/images/info.svg" height="25px" width="25px" className="chat-info-b" />
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div >
        </div >)
}


const mapStateToProps = (state) => {


    const {
        lang,
        langForm,
        chatUserSpeaking,
        isChatFirstWordDetect,
        chatSenderLanguage,
        chatTranslateMessage,
        chatTranslatorStatus,
    } = state[CHAT_CUSTOM_STORE];

    const {
        overflowMenuVisible
    } = state['features/toolbox'];

    const { messages, nbUnreadMessages, isOpen } = state['features/chat'];


    return {
        _lang: lang,
        _langForm: langForm,
        _messages: messages,
        _overflowMenuVisible: overflowMenuVisible,
        _isOpen: isOpen,
        chatUserSpeaking,
        isChatFirstWordDetect,
        chatSenderLanguage,
        chatTranslateMessage,
        chatTranslatorStatus,
        _availableDevices: state["features/base/devices"].availableDevices,
    }
}
export default connect(mapStateToProps)(ChatHeader);